import API from './base';

const version = 'v1';
const claim = '/claim';

export default {
  newClaim(payload) {
    return API.post(`${version}${claim}`, payload);
  },
};
